import React from 'react';
import './AlertDialog.css';


class AlertDialog extends React.Component {
  

  handleCancelButton = () => {
    if (this.props.close) this.props.close(false);
  }
  handleOKButton = () => {
    if (this.props.onClickOKButton) this.props.onClickOKButton();
    if (this.props.close) this.props.close(true);
  }

  render () {
    return (
      <div className="AlertDialog">
        <div className="AlertDialog-Window">
          <div className="AlertDialog-Message">
          {this.props.children}
          </div>
          <div className="AlertDialog-Buttons">
            { this.props.okButtonOnly
              ? true
              : <button className="AlertDialog-CancelButton" onClick={this.handleCancelButton}>{this.props.cancelButtonName ? this.props.okButtonName : 'キャンセル'}</button>
            }
            
            <button className="AlertDialog-OKButton" onClick={this.handleOKButton}>{this.props.okButtonName ? this.props.okButtonName : 'OK'}</button>
          </div>
        </div>
      </div>
    );
  }
}
export default AlertDialog;